import { create } from 'zustand';
import axiosInstance from '../auth/axiosInstance';

export const useGetRequests = create((set) => ({
  data: [],
  isDataFetching: false,
  dataErrorMessage: '',

  getRequests: (page, limit, query) => {
    set((state) => ({
      ...state,
      data: [],
      isDataFetched: false,
      dataErrorMessage: '',
    }));

    axiosInstance
      .get(`${process.env.REACT_APP_API_BASE_URL}/requests/admin?${query}`, {
        params: {
          page: page + 1,
          limit,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
        },
      })
      .then((res) => {
        set((state) => ({
          ...state,
          data: res.data,
          isDataFetched: true,
          dataErrorMessage: '',
        }));
      })
      .catch((error) => {
        console.log(error.response?.status);
        if (error.response?.status === 400) window.location.href = '/';
        set((state) => ({
          ...state,
          data: [],
          isDataFetched: false,
          dataErrorMessage: error.message,
        }));
      });
  },
}));
